import axios from "axios";
import { BACKEND_URL } from "../../../utils/api";

export interface InteracEmailEvent {
  id: string;
  message_id?: string | null;
  subject?: string | null;
  sender?: string | null;
  reply_to?: string | null;
  amount?: number | null;
  reference?: string | null;
  status: string;
  reason?: string | null;
  match_method?: string | null;
  has_reference?: boolean | null;
  expected_amount?: number | null;
  received_amount?: number | null;
  missing_amount?: number | null;
  credited_amount?: number | null;
  user_id?: string | null;
  wallet_history_id?: string | null;
  payment_id?: string | null;
  summary?: string | null;
  error_message?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export const interacEmailService = {
  async list(
    token: string,
    opts: {
      page?: number;
      pageSize?: number;
      status?: string;
      reason?: string;
      q?: string;
    } = {}
  ): Promise<{
    items: InteracEmailEvent[];
    pagination: { page: number; page_size: number; total: number; total_pages: number };
  }> {
    const params = new URLSearchParams({
      page: String(opts.page || 1),
      page_size: String(opts.pageSize || 25),
    });
    if (opts.status) params.set("status", opts.status);
    if (opts.reason) params.set("reason", opts.reason);
    if (opts.q) params.set("q", opts.q);
    const response = await axios.get(`${BACKEND_URL}/interac-emails/?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
  },
};
